<template>
  <v-container fluid class="policy-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/policy/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
              <v-btn color="primary" outlined class="button-shadow">
                <v-icon class="mr-2">mdi-filter-variant</v-icon>
                Filters
              </v-btn>
            </v-col>
            <v-col cols="12" md="6" class="d-flex justify-end mt-3 mt-md-0">
                <div :style="$vuetify.breakpoint.smAndDown ? 'width: 100%' : 'width: 250px'">
                <v-text-field
                  dense
                  :full-width=$vuetify.breakpoint.smAndDown
                  outlined
                  hide-details
                  label="Search"
                  prepend-inner-icon="mdi-magnify"
                ></v-text-field>
              </div>
            </v-col>
            <v-col cols="12" class="d-flex justify-end mt-3">

            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="policies-table"
              show-select
              single-select
              item-key="_id"
              sort-by="policystatus"
              :footer-props="footer"
              :headers="headers"
              :items="policies"

              :items-per-page="policyPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Policy?
                    </v-card-title>
                    <v-card-text>
                      {{ deletepolicy.policycode }}
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deletePolicy(deletepolicy)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.policystatus="{ item }">
                <v-chip
                  :color="item.policystatus=='Active' ? 'success white--text' : 'secondaryConst white--text'"
                  small>
                  {{ item.policystatus }}
                </v-chip>
              </template>
              <template v-slot:item.policydate="{ item }">
                {{ new Date(item.policydate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.updatedAt="{ item }">
                {{ new Date(item.updatedAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editPolicy(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="printItem(item)">
                  <v-icon>mdi-printer</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'PolicyList',
  data() {
    return {
      dialog: false,
      deletepolicy: {},
      headers: [
        { text: 'Code', value: 'policycode'},
        { text: 'Type', value: 'policytype'},
        { text: 'Name', value: 'policyname'},
        { text: 'Status', value: 'policystatus'},
        { text: 'Date', value: 'policydate' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      policyPerPage: 500,
      selected: [],      
    }
  },
  computed: {
    ...mapState('Policy', ['policies', 'isReceiving', 'isDeleting', 'idToDelete', 'isUpdating']),
    formTitle () {
      return this.editedIndex === -1 ? 'New Policy' : 'Edit Policy'
    },
  },
  created () {
    this.getPoliciesRequest()
  },

  methods: {
    ...mapActions('Policy', [
      "createPolicyRequest",
      "deletePolicyRequest",
      "getPoliciesRequest",
      "updatePolicyRequest",
    ]),
    editPolicy(item) {
      this.$router.push({ name: 'PolicyEdit', params: item })
    },
    deletePolicy(item) {
      this.deletePolicyRequest({_id: item._id});
      this.dialog = false;
    },
    deleteDialog(item) {
      this.dialog = true;
      this.deletepolicy = {
        _id: item._id,
        policycode: item.policycode,
      }
    },
    printItem(item) {
      let params = Object.assign({}, item);
      params.isFromAdm = true;
      this.$router.push({ name: 'PolicyPrint', params: params })
    },
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
